export default "__VITE_ASSET__BgJXD_Co__"